<template>
  <div>
    <div style="white-space: nowrap; font-size: 0;">
      <div style="display: inline-block; width: 45%; vertical-align: top;font-size: var(--font-large);;">
        <el-button size="small" type="warning" @click="onStart"
          v-if="!this.techExpertStatus && hasRoles(['Tech expertise operator', 'Tech expertise manager'])">
          <i class="fa-solid fa-play"></i> {{$t('Qəbul_et_və_başla')}}
        </el-button>
        <div v-if="this.techExpertStatus">
          <div style="background-color:#8E9A9B; color: white; padding:3px; width: 95%;">
            <span>Qiymətləndirici tərəfindən iş başlanmışdır:</span>
            <span>{{ techExpertStatus.createdBy }}</span>
          </div>
        </div>
      </div>
      <div style="display: inline-block; width: 20%; vertical-align: top; font-size: var(--font-large);;"
        v-if="this.techExpertStatus">
        <status-label :type="expertItem.statusTypeId === 70 ? 'goldenrod' : 
            expertItem.statusTypeId === 75 ? 'limeGreen' :
            expertItem.statusTypeId === 80 ? 'mediumBlue' :
            expertItem.statusTypeId === 95 ? 'greenYellow' :
            expertItem.statusTypeId === 110 ? 'coral' :
            expertItem.statusTypeId === 125 ? 'salmon' :
            expertItem.statusTypeId === 130 ? 'olive' :
            expertItem.statusTypeId === 131 ? 'lightblue' :
            expertItem.statusTypeId === 135 ? 'forestGreen' : ''" />
        {{ expertItem.statusTypeName }}
      </div>

      <div style="display: inline-block; width: 35%; text-align: right; vertical-align: top; font-size: var(--font-large);"
        v-if="this.techExpertStatus">
        <el-button size="small"
          v-if="this.techExpertStatus && hasRoles(['Tech expertise operator', 'Tech expertise manager'])" type="success"
          @click="handleFinish">
          <i class="el-icon-circle-check"></i>{{ buttonLabel }}
        </el-button>
        <el-button size="small"
          v-if="this.techExpertStatus && hasRoles(['Tech expertise manager']) && this.claimStatus === 136" type="danger"
          @click="openDialog">
          <i class="fa-solid fa-rotate-left"></i>{{$t('Geri_qaytar')}}
        </el-button>
        <el-button size="small" type="warning" @click="openCarepModal = true">
          <i class="el-icon-circle-check"></i> {{$t('Carepə_göndər')}}
        </el-button>
      </div>
    </div>
    <card v-if="this.claimStatus === 137">

      <div>
        <titles :text="$t('Geri_qaytarılıb')"></titles>
        <br>
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in rejectClaim" :key="index" :icon="activity.icon"
            :type="activity.type" :color="'#B3005E'" :size="activity.size"
            :timestamp="formatDateTime(activity.createDate)">
            <span style="font-size: var(--font-primary);font-weight: bold;">{{$t('Geri_qaytaran')}}: </span><span
              style="font-size: var(--font-primary);" span>{{ activity.createUserName }}</span>
            <br>
            <span style="font-size: var(--font-primary);">{{$t('Səbəb')}}: </span>{{ activity.reason }}
          </el-timeline-item>
        </el-timeline>

      </div>
    </card>
    <br />
    <!-- <el-button type="success" @click="showModalCarep = true">
      <i class="fa-solid fa-play"></i>
      Carepə göndər
    </el-button> -->
    <div v-if="this.techExpertStatus">
      <assessments @refresh="getClaimTechExpert" :claimId="Number(this.id)" />
    </div>
    {{ item.policyType }}
    <div v-if="this.techExpertStatus">
      <internal-evaluation @refresh="getData" :value="expertItem" :policyType="item.policyType" />
    </div>
    <div v-if="this.techExpertStatus && (this.item.policyType === 1 || this.item.policyType === 0)">
      <service-evaluation :key="serviceEvaluationKey" @refresh="getClaimTechExpert" :service="serviceCenterId"
        :value="expertItem" />
    </div>
    <div v-if="this.techExpertStatus">
      <indepentend-evaluation @refresh="getClaimTechExpert" :value="expertItem" />
    </div>

    <el-collapse v-loading="loading" value="1">
      <el-collapse-item name="1">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-headphones-simple"></i>
            &nbsp;
            <span>{{$t('Çağrı_mərkəzinin_qeydləri')}}</span>
          </div>
        </template>
        <div>
          <accident-base :value="accidents"></accident-base>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-loading="loading" value="2">
      <el-collapse-item name="2">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-person-military-pointing"></i>
            &nbsp;
            <span>{{$t('Komissarın_qeydləri')}}</span>
          </div>
        </template>
        <accident-comm-base :value="comm"></accident-comm-base>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-loading="loading" value="3">
      <el-collapse-item name="3">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-people-arrows-left-right"></i>
            &nbsp;
            <span>{{$t('İştirakçılar')}}</span>
          </div>
        </template>
        <card>
          <el-form v-loading="partloading">
            <div class="row">
              <div class="col-md-6 col-12" v-for="item in participants" :key="item.id">
                <div v-if="item.policyType === null || item.policyType === 1">
                  <participant-card :item="item" :readonly="true" @refresh="getParticipants"
                    @edit="editParticipant(item.id)" @delete="deleteParticipant" @report="reportParticipant(item.id)" />
                </div>
                <div v-else>
                  <other-participant-card :item="item" :readonly="true" @refresh="getParticipants"
                    @edit="editParticipant(item.id)" @delete="deleteParticipant" @report="reportParticipant(item.id)" />
                </div>
              </div>
            </div>
          </el-form>

        </card>
      </el-collapse-item>
    </el-collapse>
    <el-dialog :visible.sync="rejectVisible" width="30%" top="30vh" title="Səbəb">
      <el-input v-model="rejectItem.reason" :placeholder="$t('Səbəb')"></el-input>
      <div style="height: 20px;"></div>


      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkReasonBeforeConfirm()">{{$t('Bəli')}}</el-button>
        <el-button @click="rejectVisible = false">{{$t('Xeyr')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Təmir mərkəzi seçin" :visible.sync="openCarepModal" width="30%" top="30vh" append-to-body
      :close-on-press-escape="false" :close-on-click-modal="false">

      <div v-loading="careploading">
        <carep-contracts v-model="selectedCenter" @update:name="selectedCenterName = $event" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="openCarepModal = false">{{$t('İmtina')}}</el-button>
        <el-button size="small" type="primary" @click="handleNextStep">Növbəti</el-button>
      </span>
    </el-dialog>


    <file-selection-modal :files="files" :selectedFiles.sync="selectedFiles"
      :openFileSelectionModal.sync="openFileSelectionModal" :selectedImage.sync="selectedImage"
      :imageModalVisible.sync="imageModalVisible" :loading="careploading" @publish="handlePublish" />


    <participant ref="participant" @saved="getParticipants" />
    <report-participant ref="report" @saved="getParticipants" />
    <other-participant ref="otherParticipant" @saved="getParticipants" />
    <!-- <div v-show="false">

      <repair-stages :actType="1" :readonly="true" :value="1"></repair-stages>
    </div> -->
  </div>
</template>

<script>
  import {
    GetAccident,
    GetCommData,
    GetAccidentsByStatus,
    GetParticipants,
  } from "../../services/accident";
  import {
    CreateTechExpert,
    TechExpertUserUpdate,
    GetClaim,
    GetClaimTechExpert,
    FinishTechExpert,
    LastClaimStatus,
    SendTechExpertApproval,
    TechExpertReject,
    GetTechExpertReject
  } from "../../services/claim";
  import { EventBus } from '../../services/eventbus';
  import { CheckStatusCount, LastAssessmentStatus } from "src/services/common";
  import Assessments from "../components/Assessments.vue";
  import AccidentBase from "../components/AccidentBase.vue";
  import AccidentCommBase from "../components/AccidentCommBase.vue";
  import InternalEvaluation from "../components/InternalEvaluation.vue";
  import ServiceEvaluation from "../components/ServiceEvaluation.vue";
  import IndepentendEvaluation from "../components/IndepentendEvaluation.vue";
  // import ServiceCenterResult from "../components/ServiceCenterResult.vue";
  import Participant from "../components/Participant.vue";
  import ParticipantCard from "../components/ParticipantCard.vue";
  import StatusLabel from "../components/StatusLabel.vue";
  import ReportParticipant from "../components/ReportParticipant.vue";
  // import RepairStages from "../components/RepairStages.vue";
  import OtherParticipantCard from "../components/OtherParticipantCard.vue";
  import OtherParticipant from "../components/OtherParticipant.vue";
  import CarepContracts from "../components/CarepContracts.vue";
  import { GetApiToken, SendReferral, UploadReferralFiles, PublishReferral, GetClaimReferral, CreateReferral, GetClaimReferralsById } from "../../services/carep";
  import { GetFiles } from "../../services/files";
  import FileSelectionModal from '../components/FileSelectionModal.vue';
  import { formatDateTime, labelPosition } from "../../services/helper";
  import Titles from "../components/Titles.vue";

  export default {
    props: {
      id: [String, Number],
    },
    components: {
      Titles,
      AccidentBase,
      AccidentCommBase,
      InternalEvaluation,
      ServiceEvaluation,
      IndepentendEvaluation,
      Participant,
      ParticipantCard,
      StatusLabel,
      Assessments,
      ReportParticipant,
      // RepairStages,
      OtherParticipantCard,
      OtherParticipant,
      CarepContracts,
      FileSelectionModal
    },
    computed: {
      sumsOverThreshold() {
        const threshold = 1500;
        return (this.expertItem.finishExpertSum > threshold || this.expertItem.finishServiceSum > threshold || this.expertItem.finishIndepentendExpertSum > threshold) && this.roles.includes("Tech expertise operator");
      },
      buttonLabel() {
        return this.sumsOverThreshold
          ? this.$t('Təsdiqə_göndər')
          : this.$t('Müştəri_xidmətinə_göndər');
      }

    }
    ,
    data() {
      return {
        loading: false,
        commloading: false,
        careploading: false,
        partloading: false,
        item: {},
        comm: {},
        techExpertStatus: {},
        participants: [],
        claims: {},
        accidents: {},
        expertData: {},
        expertItem: {},
        serviceCenterId: null,
        statusCount: 0,
        uid: this.$store.state.user.id,
        assessmentStatus: null,
        roles: this.$store.state.user.roles,
        rejectVisible: false,
        rejectItem: {},
        rejectClaim: [],
        claimStatus: null,
        claimReferral: {},
        showModalCarep: false,
        selectedCenter: null,
        selectedCenterName: '',
        openCarepModal: false,
        openFileSelectionModal: false,
        imageModalVisible: false,
        files: [],
        selectedFiles: [],
        selectedImage: '',
        referralId: null,
        serviceEvaluationKey: 0,
        labelPosition: labelPosition,
      };
    },


    methods: {
      formatDateTime,
      map() {
        this.$refs["mapcontrol"].show(this.comm.lat, this.comm.lng);
      },
      saveUser() {
        TechExpertUserUpdate(this.id, this.expertItem.techExpertUid, this.uid).then(
          (response) => {
            this.loading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {
                this.$message({
                  type: "success",
                  message: "Məsul şəxs seçildi",
                });
                this.getData();
              }
            } else {
              this.$message({
                type: "error",
                message: "Səhv əməliyyat",
              });
            }
          }
        );
      },
      openDialog() {
        this.rejectVisible = true;
      },
      checkReasonBeforeConfirm() {
        if (!this.rejectItem.reason) {
          this.$message({
            type: "warning",
            message: "Səbəb yazılmayıb",
          });
          return;
        }
        if (this.claimStatus === 137) {
          this.$message({
            type: "warning",
            message: "Daha öncə geri qaytarılıb",
          });
          return;
        }

        this.rejectTechExpert()
      },
      rejectTechExpert() {
        this.loading = true;
        this.rejectItem.id = this.id;
        this.rejectItem.commandUserId = this.uid;
        this.rejectItem.rejectType = 3;
        const handleResponse = (response) => {
          this.loading = false;
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0] ? response.data.errors[0] : "Səhv əməliyyat",
              });
            } else {

              this.$message({
                type: "success",
                message: "Uğurlu əməliyyat",
              });

              this.getData();
            }
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        }

        TechExpertReject(this.rejectItem).then(handleResponse);
        this.$router.push('/techexpert/claims')


      },
      getTechExpertReject() {
        GetTechExpertReject(this.id, 3).then((response) => {
          this.loading = false;
          if (response.data) {
            this.rejectClaim = response.data;
          }
        });
      },
      hasRoles(requiredRoles) {
        return requiredRoles.some(role => this.roles.includes(role));
      },
      onStart() {
        this.$confirm("İş üzrə qiymətləndirmə başlandı?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        }).then(() => {
          this.expertData.id = 0;
          this.expertData.claimId = this.id;
          this.expertData.commandUserId = this.uid
          this.commloading = true;
          CreateTechExpert(this.expertData).then((response) => {
            this.commloading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {
                this.$message({
                  type: "success",
                  message: "Uğurlu əməliyyat",
                });
                this.getData();
              }
            } else {
              this.$message({
                type: "error",
                message: "Səhv əməliyyat",
              });
            }
          });
        });
      },
      sendTechExpertApproval(id) {
        if (this.claimStatus === 136) {
          this.$message({
            type: "warning",
            message: "Daha öncə təsdiqə göndərilib",
          });
          return;
        }
        this.$confirm("İş təsdiqə göndərilsin?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        })
          .then(() => {
            this.loading = true;

            SendTechExpertApproval(id, this.uid).then((response) => {
              this.loading = false;
              if (response.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "Təsdiqə göndərildi",
                  });
                  this.getData();
                  this.$router.push('/techexpert/claims');
                }
              } else {
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              }
            });
          })
          .catch(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },
      handleFinish() {
        this.lastClaimStatus().then(() => {
          const sumsOverThreshold = [this.expertItem.finishExpertSum, this.expertItem.finishServiceSum, this.expertItem.finishIndepentendExpertSum]
            .some(sum => sum > 1500);
          const isTechExpertOperator = this.roles.includes("Tech expertise operator");
          if (sumsOverThreshold && isTechExpertOperator) {
            this.sendTechExpertApproval(this.id);
          } else {
            if (this.claimStatus >= 140) {
              this.$message({
                type: "warning",
                message: "Daha öncə Müştəri xidmətlərinə göndərilib",
              });
            } else if (![6, 4, 7].includes(this.assessmentStatus)) {
              this.$message({
                type: "warning",
                message: "İş barədə son əməliyyat statusu seçilməyib",
              });
            } else if (this.expertItem.initialExpertUid && !this.expertItem.finishExpertSum) {
              this.$message({ type: "warning", message: "Daxili qiymətləndirmədə yekun məbləği qeyd olunmayıb" });
            } else if (this.expertItem.initialServiceUid && !this.expertItem.finishServiceSum) {
              this.$message({ type: "warning", message: "Təmir mərkəzinin qiymətlənləndirilməsində yekun məbləğ qeyd olunmayıb" });
            } else if (this.expertItem.initialIndepentendExpertUid && !this.expertItem.finishIndepentendExpertSum) {
              this.$message({ type: "warning", message: "Müstəqil ekspert qiymətləndirilməsində yekun məbləğ qeyd olunmayıb" });
            } else if (!this.expertItem.finishExpertSum && !this.expertItem.finishServiceSum && !this.expertItem.finishIndepentendExpertSum) {
              this.$message({ type: "warning", message: "Yekun məbləğ qeyd olunmayıb" });
            } else {
              this.$confirm("İş müştəri xidmətlərinə göndərilsin?", "Təsdiqləyin", {
                confirmButtonText: this.$t('Bəli'),
                cancelButtonText: this.$t('Xeyr'),
                type: "info",
              }).then(() => {
                this.loading = true;
                FinishTechExpert(this.id, this.uid).then((response) => {
                  this.loading = false;
                  if (response.data) {
                    if (!response.data.isSuccess) {
                      this.$message({
                        type: "error",
                        message: response.data.errors[0],
                      });
                    } else {
                      this.$message({
                        type: "success",
                        message: "Uğurlu əməliyyat",
                      });
                      this.getData();
                      this.$router.push('/techexpert/claims');
                    }
                  } else {
                    this.$message({
                      type: "error",
                      message: "Səhv əməliyyat",
                    });
                  }
                });
              }).catch(() => {
                this.loading = false;
              });
            }
          }
        });
      }
      ,
      reportParticipant(id, accidentId, createUserId) {
        this.$refs["report"].edit(id, accidentId, createUserId, true);
      },
      editParticipant(id) {
        if (this.item.policyType === 1 && this.item.policyType)
          this.$refs["participant"].edit(id, true);
        else
          this.$refs["otherParticipant"].edit(id, true);

      },
      checkStatusCount(id) {

        this.statusCount = 0;
        return new Promise((resolve, reject) => {
          CheckStatusCount(0, id, 140).then((response) => {
            if (response.data) {
              this.statusCount = response.data;
            }
            resolve(this.response);
          }, error => {
            reject(error);
          })
        })
      },
      getCommData() {
        this.commloading = true;
        GetCommData(this.item.accidentId).then((response) => {
          this.commloading = false;
          if (response.data) {
            this.comm = response.data.data?.[0];
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        });
      },
      async getClaimTechExpert() {
      try {
        const response = await GetClaimTechExpert(this.id);
        if (response.data) {
          this.expertItem = response.data.data?.[0];
          this.lastAssessmentStatus();
        }
      } catch (error) {
        this.$message({ type: "error", message: "Texniki ekspert məlumatları gətirilərkən səhv baş verdi." });
      }
    },
      lastAssessmentStatus() {
        return new Promise((resolve, reject) => {
          LastAssessmentStatus(this.id).then((response) => {
            if (response.data) {
              this.assessmentStatus = response.data;
            }
            resolve(this.response);
          }, error => {
            reject(error);
          })
        })
      },
      async getData() {
        this.loading = true;
        try {
          const response = await GetClaim(this.id);
          this.loading = false;
          if (response.data) {
            this.item = response.data.data?.[0];
            this.getClaimTechExpert();
            this.getAccident();
            this.getCommData();
            this.getTechExpertStatus();
            this.getParticipants();
            await this.lastClaimStatus();
            this.lastAssessmentStatus();
            this.getTechExpertReject();
            this.getClaimReferral();
          } else {
            this.$message({
              type: "warning",
              message: "Səhv əməliyyat",
            });
          }
        } catch (error) {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Bir səhv baş verdi",
          });
        }
      },
      getParticipants() {
        this.partloading = true;
        GetParticipants(this.item.accidentId).then((response) => {
          this.partloading = false;
          if (response.data) {
            this.participants = response.data.data;
          }
        });
      },
      async lastClaimStatus() {
        try {
          const response = await LastClaimStatus(this.id);
          if (response) {
            this.claimStatus = response.data;
          } else {
          }
        } catch (error) {
        }
      },
      checkServiceCenterId() {
        if (!this.participants || this.participants.length === 0) return false;

        const typeOneParticipants = this.participants.filter(participant => participant.participantType === 1);

        if (typeOneParticipants.length === 0) return false;

        const firstTypeOneParticipant = typeOneParticipants[0];

        return !!firstTypeOneParticipant.serviceCenterId;
      },
      getAccident() {
        this.loading = true;
        GetAccident(this.item.accidentId).then((response) => {
          this.loading = false;
          if (response.data) {
            this.accidents = response.data.data?.[0];
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        });
      },
  async getTechExpertStatus() {
      try {
        const response = await GetAccidentsByStatus(0, this.id, 80, this.uid);
        this.techExpertStatus = response.data.data?.[0] || null;
      } catch (error) {
        this.$message({ type: "error", message: "Texniki ekspert statusu gətirilərkən səhv baş verdi." });
        this.techExpertStatus = null;
      }
    },
      async handleNextStep() {
        try {
          this.careploading = true;

          const tokenResponse = await GetApiToken();
          const jwtToken = tokenResponse.result.jwt;

          await this.getClaimReferral();

          if (!this.claimReferral) {
            this.$message({
              type: "error",
              message: "Claim Referral not data.",
            });
            return;
          }

          let custombrand = '';
          let custommodel = '';
          if (this.claimReferral.customBrandModel) {
            const parts = this.claimReferral.customBrandModel.split(' ');
            custombrand = parts[0];
            custommodel = parts.slice(1).join(' ');
          }
          const platetype = this.claimReferral.regNumber && this.claimReferral.regNumber.length === 7 ? 1 : 2;

          const referralData = {
            centerid: this.selectedCenter,
            referraldate: '2024-10-18',
            modelid: 1,
            custombrand: custombrand || '',
            custommodel: custommodel || '',
            regnumber: this.claimReferral.regNumber.replace(/^(\d{2})([A-Z]{2})(\d{3})$/, "$1-$2-$3"),
            platetype: platetype,
            engine: platetype,
            production: this.claimReferral.production || 0,
            vin: this.claimReferral.vin || '',
            mileage: this.claimReferral.mileage || 0,
            policynumber: this.claimReferral.dispClaimNumber || '',
            clientname: this.claimReferral.respPersonName || '',
            clientemail: '',
            clientphone: this.claimReferral.respPersonPhone || '',
            respperson: 'Insurance Test User',
            resppersonphone: '+994550000000',
            resppersonemail: 'instest@huestimates.com',
          };

          const referralResponse = await SendReferral(referralData, jwtToken);
          this.referralId = referralResponse.result.trim();


          const updatedData = {
            ...referralData,
            claimId: this.id,
            referralId: this.referralId,
            serviceCenterId: this.selectedCenter,
            serviceCenterName: this.selectedCenterName,
          };

          await CreateReferral(updatedData);


          this.$message.success("Göndəriş yaradıldı.");

          await this.getClaimReferrals();
          this.openCarepModal = false;
          this.openFileSelectionModal = true;
          this.accidentCommId = this.referrals.length > 0 ? this.referrals[0].accidentCommId : null;
          const fileData = await GetFiles(1, this.accidentCommId);
          // const fileData = await GetFiles(1, 55);
          this.files = fileData.map(file => ({
            id: file.id,
            fileName: file.fileName,
            url: file.url
          }));
        } catch (error) {
          console.error("Səhv əməliyyat:", error);
        } finally {
          this.careploading = false;
        }
      },

      async handlePublish() {
        try {
          this.careploading = true;

          const tokenResponse = await GetApiToken();
          const jwtToken = tokenResponse.result.jwt;

          await UploadReferralFiles(this.selectedFiles, this.referralId, jwtToken);
          await PublishReferral(this.referralId, jwtToken);
          this.$message.success("Fayllar yükləndi və dərc olundu");
          this.openFileSelectionModal = false;
          this.serviceEvaluationKey += 1;
          window.open(`#/carep/${this.referralId}`, '_blank');
        } catch (error) {
          console.error("Səhv əməliyyat", error);
          this.$message.error("Yükləmə prosesi uğursuz oldu.");
        } finally {
          this.careploading = false;
        }
      },

      showImage(url) {
        this.selectedImage = url;
        this.imageModalVisible = true;
      },

      getClaimReferral() {
        return GetClaimReferral(this.id).then((response) => {
          if (response.data) {
            this.claimReferral = response.data;
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyats",
            });
          }
        });
      },
      async getClaimReferrals() {
        if (this.referralId) {
          try {
            const response = await GetClaimReferralsById(0, this.referralId);
            this.referrals = Array.isArray(response.data) ? response.data : [];

          } catch (error) {
            this.$message.error('Error loading referrals data');
          }
        } else {
          console.warn("ID not found");
        }
      }

    },
    mounted() {
      this.getData();
    },
  };
</script>

<style lang="scss" scoped>
  .thumbnail {
    width: 50px;
    height: 50px;
    cursor: pointer;
    margin-right: 5px;
    border: 1px solid #ddd;
  }
</style>